import type { ReactNode } from "react";
import { Stack } from "@mui/material";

import { cn } from "../utils/styling";

export type Tab = {
  disabled?: boolean;
  displayName?: ReactNode;
  name: string;
  onClick?: () => void;
};

type NavigationTabsProps = {
  activeTab: Tab;
  className?: string;
  setActiveTab: (tab: Tab) => void;
  tabs: Tab[];
};

export const NavigationTabs = ({ activeTab, className, setActiveTab, tabs }: NavigationTabsProps) => {
  return (
    <Stack className={cn("font-ds-headline-xs mb-2 w-full gap-8 !border-2 border-b-ds-soft", className)}>
      {tabs?.map((tab, index) => {
        const isActive = tab.name === activeTab.name;
        const isDisabled = Boolean(tab.disabled);
        return (
          <span
            className={cn(
              "mb-[-2px] px-4 py-2 uppercase",
              isDisabled && "cursor-not-allowed text-lds-foreground-disabled",
              !isDisabled && "cursor-pointer",
              !isDisabled &&
                isActive &&
                "!border-2 text-lds-foreground-heading-active border-b-ds-accent",
              !isDisabled &&
                !isActive &&
                "!border-1 text-lds-foreground-heading-initial border-b-ds-soft hover:!border-2 hover:text-lds-foreground-heading-hover hover:border-b-ds-accent"
            )}
            key={index}
            onClick={() => {
              if (isDisabled) return;
              setActiveTab(tab);
            }}
          >
            {tab.displayName ?? tab.name}
          </span>
        );
      })}
    </Stack>
  );
};
